import { useEffect } from "react";
import { CheckCircle2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { isFormSubmitted, openPaymentPage, openTallyPopup } from "@/booking";

const PaymentReadyView = () => (
  <div data-testid="booking-payment-ready" className="flex flex-col items-center gap-4 px-9 py-10 text-center">
    <span className="flex h-14 w-14 items-center justify-center rounded-full bg-peach-soft">
      <CheckCircle2 size={30} className="text-peach-dark" />
    </span>
    <p className="font-heading text-lg font-bold text-ink">Your details are saved</p>
    <p className="max-w-sm text-sm leading-relaxed text-ink-muted">
      Complete the ₹199 payment on Razorpay to confirm your strategy call.
    </p>
    <button
      data-testid="booking-open-payment-btn"
      onClick={openPaymentPage}
      className="mt-2 flex items-center justify-center gap-2 rounded-full bg-peach-dark px-8 py-4 font-heading text-sm font-bold text-cream shadow-[0_16px_40px_-14px_rgba(226,121,111,0.8)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-peach-deeper"
    >
      Open Payment Page — ₹199
    </button>
  </div>
);

export const BookingModal = ({ open, onOpenChange }) => {
  const alreadySubmitted = isFormSubmitted();

  useEffect(() => {
    if (open && !alreadySubmitted) {
      onOpenChange(false);
      openTallyPopup();
    }
  }, [open, alreadySubmitted, onOpenChange]);

  return (
    <Dialog open={open && alreadySubmitted} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="booking-modal"
        className="max-h-[92vh] max-w-lg overflow-y-auto rounded-[2rem] border-peach/25 bg-cream p-0 shadow-2xl"
      >
        <div className="bg-gradient-to-br from-cream-dark to-white px-6 pb-3 pt-6 sm:px-8">
          <DialogHeader>
            <p className="text-[10px] font-heading font-bold uppercase tracking-[0.28em] text-peach-dark">
              Strategy Call · ₹199
            </p>
            <DialogTitle className="mt-1 font-heading text-2xl font-extrabold tracking-tight text-ink">
              Complete Your Payment
            </DialogTitle>
            <DialogDescription className="pt-1 text-sm leading-relaxed text-ink-muted">
              Your booking details are already saved. One final step to confirm your call.
            </DialogDescription>
          </DialogHeader>
        </div>

        <PaymentReadyView />
      </DialogContent>
    </Dialog>
  );
};


